import checkForNegativePurpose from "./check_for_negative_purpose";
import checkConsentExpireTime from "./check_expire_time";
import { boundShowGdpr } from "../../redux/actions/display";
import updateConsent from "./update_consent";
import store from "../../redux/store";

const checkState = () => {
    // checks for negative 
    // if present checks expire time: 1 week
    // if expired ---> pop
    // no negatives
    // checks expire time: 1 year
    // if expired ---> pop
    // else update the consent string with new lastUpdated date

    if (checkForNegativePurpose()) {
        if (checkConsentExpireTime()) {
            boundShowGdpr();
        }
    } else {
        if (checkConsentExpireTime(store.getState().expireTimeAllPositive)) {
            boundShowGdpr();
        }
        updateConsent();
    }
}

export default checkState